// Module
var code = "<p>The torus is deformed with a noise SOP, and the box is maintained in its center with the centroid expression</p> ";
// Exports
export default code;